module.exports = __webpack_public_path__ + "img/location@3x.47c9b105.png";